import { Icon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  IconButton,
  Input,
  InputGroup,
  InputRightAddon,
  SystemStyleObject,
  Text,
} from "@chakra-ui/react";
import LabelComponent from "../../atom/Label/LabelComponent";
import { ChangeEvent, FC, useState } from "react";
import { borderColor, primaryColor } from "../../../utils/colors";

interface InputFieldComponentProps {
  label: string;
  name: string;
  type: string;
  register: any;
  errors: any;
  icon?: React.ElementType;
  isRequired?: boolean;
  isDisabled?: boolean;
  additionalStyle?: SystemStyleObject;
  additionalIconStyle?: SystemStyleObject;
  extraText?: string;
  isPassword?: boolean;
  counter?: number;
  hasErrorBorder?: boolean; // ✅ novo
}

const InputFieldComponent: FC<InputFieldComponentProps> = ({
  label,
  name,
  register,
  errors,
  type,
  icon,
  isRequired = false,
  isDisabled = false,
  additionalStyle,
  additionalIconStyle,
  extraText,
  isPassword = false,
  counter,
  hasErrorBorder,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [inputLength, setInputLength] = useState(0);
  const { onChange: registerOnChange, ...registerProps } = register(name);

  const handleClick = () => {
    if (isPassword) {
      setShowPassword((prev) => !prev);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (counter) {
      setInputLength(e.target.value.length);
    }
    registerOnChange(e);
  };

  const inputType = isPassword && showPassword ? "text" : type;

  return (
    <Box position="relative">
      <FormControl isInvalid={!!errors[name]} sx={additionalStyle}>
        <LabelComponent
          title={label}
          fontWeight="500"
          fontSize="md"
          {...(isRequired && { isRequired })}
        />

        <Flex gap={2.5} alignItems="flex-end">
          <InputGroup>
            <Input
              minWidth="32"
              type={inputType}
              {...registerProps}
              isDisabled={isDisabled}
              maxLength={counter ? counter : undefined}
              onChange={counter ? handleInputChange : registerOnChange}
              sx={{
                borderColor: hasErrorBorder ? "#E53E3E" : borderColor, // ✅ vermelho se erro
                boxShadow: hasErrorBorder ? "0 0 0 1px #E53E3E" : "none", // borda visível
                "&:focus": {
                  borderColor: hasErrorBorder ? "#E53E3E" : primaryColor, // mantém vermelho no focus
                  boxShadow: hasErrorBorder
                    ? "0 0 0 1px #E53E3E"
                    : "0 0 0 1px rgba(66, 153, 225, 0.6)",
                },
              }}
            />

            {(isPassword || icon) && (
              <InputRightAddon p={0}>
                {isPassword ? (
                  <IconButton
                    aria-label={showPassword ? "Ocultar" : "Mostrar"}
                    variant="solid"
                    icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                    color={primaryColor}
                    onClick={handleClick}
                    borderY="1px solid"
                    borderX="0"
                    borderColor={borderColor}
                  />
                ) : (
                  <Icon
                    as={icon}
                    sx={additionalIconStyle}
                    borderY="1px solid"
                    borderX="0"
                    m="4"
                    borderColor={borderColor}
                  ></Icon>
                )}
              </InputRightAddon>
            )}
          </InputGroup>

          {extraText && (
            <Text whiteSpace="nowrap" pb="2">
              {extraText}
            </Text>
          )}
        </Flex>

        <FormErrorMessage>
          {errors[name] && errors[name].message}
        </FormErrorMessage>
      </FormControl>

      {counter && (
        <Box position="absolute" right="0" fontSize="sm">
          {inputLength}/{counter} caracteres
        </Box>
      )}
    </Box>
  );
};

export default InputFieldComponent;
